import { AfterViewInit, ChangeDetectorRef, Component, effect, ElementRef, HostListener, inject, NgZone, OnDestroy, PLATFORM_ID, TemplateRef, viewChild, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Color, ScaleType } from '@swimlane/ngx-charts';

import { isPlatformBrowser } from '@angular/common';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { environment } from '../../../environments/environment';
import { PresaleDataService } from '../../services/connection-services/data.service';
import { EvmPurchseService } from '../../services/evm-services/evm-purchase.service';
import { StakingService } from '../../services/evm-services/staking.service';
import { PixelService } from '../../services/pixel.service';
import { PopupService } from '../../services/popup.service';
import { SwapStatus, convertNum, getParamWithoutCookie } from '../../shared/constants/app-enums';
import { IStakeData } from '../../shared/interfaces/wallet.interface';
import { ClaimComponent } from '../claim/claim.component';
import { AnalyticsService } from './../../services/analytics.service';

interface IReward {
  name: string;
  value: number;
}

declare global {
  interface Window {
    initRingsAnimation: (container?: HTMLElement) => { destroy: () => void };
  }
}

@Component({
  selector: 'app-staking',
  templateUrl: './staking.component.html',
  styleUrls: ['./staking.component.scss'],
  standalone: false,
})
export class StakingComponent implements AfterViewInit, OnDestroy {
  private ngZone = inject(NgZone);
  readonly graphCont = viewChild.required<ElementRef>('graphCont');
  @ViewChild('ringsCanvas') ringsCanvas!: ElementRef<HTMLDivElement>;
  private ringsAnimationDestroy?: () => void;
  isPresalestarted = false;

  rewards: IReward[] = [
    {
      name: 'Aug-2024', //1
      value: 18833333333,
    },
    {
      name: 'Sep-2024', //2
      value: 18866666667,
    },
    {
      name: 'Oct-2024', //3
      value: 18900000000,
    },
    {
      name: 'Nov-2024', //4
      value: 18933333333,
    },
    {
      name: 'Dec-2024', //5
      value: 18966666667,
    },
    {
      name: 'Jan-2025', //6
      value: 19000000000,
    },
    {
      name: 'Feb-2025', //7
      value: 19033333333,
    },
    {
      name: 'Mar-2025', //8
      value: 19066666667,
    },
    {
      name: 'Apr-2025', //9
      value: 19100000000,
    },
    {
      name: 'May-2025', //10
      value: 19133333333,
    },
    {
      name: 'Jun-2025', //11
      value: 19166666667,
    },
    {
      name: 'Jul-2025', //12
      value: 19200000000,
    },
    {
      name: 'Aug-2025', //13
      value: 19233333333,
    },
    {
      name: 'Sept-2025', //14
      value: 19266666667,
    },
    {
      name: 'Oct-2025', //15
      value: 19300000000,
    },
    {
      name: 'Nov-2025', //16
      value: 19333333333,
    },
    {
      name: 'Dec-2025', //17
      value: 19366666667,
    },
    {
      name: 'Jan-2026', //18
      value: 19400000000,
    },
    {
      name: 'Feb-2026', //19
      value: 19433333333,
    },
    {
      name: 'Mar-2026', //20
      value: 19466666667,
    },
    {
      name: 'Apr-2026', //21
      value: 19500000000,
    },
    {
      name: 'May-2026', //22
      value: 19533333333,
    },
    {
      name: 'Jun-2026', //23
      value: 19566666667,
    },
    {
      name: 'Jul-2026', //24
      value: 19600000000,
    },
  ];

  fitContainer: boolean = true;
  view: [number, number] = [400, 200];
  showXAxis = true;
  showYAxis = true;
  gradient = false;
  legendTitle: string = 'Total Rewards';
  legendPosition: string = 'below'; // ['right', 'below']
  showLegend = false;
  showXAxisLabel = true;
  xAxisLabel = 'Months';
  showYAxisLabel = true;
  yAxisLabel = 'Supply';
  SwapStatus = SwapStatus;
  showGridLines: boolean = true;
  showDataLabel: boolean = false;
  pageLoaded: boolean = false;
  maxYAxis = 100;
  minYAxis = 0;
  stakeUnlockTime: number = environment.stakeUnlockTime;
  stakeAmount!: number;
  colorScheme: Color = {
    name: 'myScheme',
    selectable: true,
    group: ScaleType.Ordinal,
    domain: [
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
      '#87878780',
    ],
  };

  lang: string = '';
  timeInterval!: ReturnType<typeof setInterval>;
  cryptoName: string = environment.tokenName;

  walletAddress!: string;
  stakeData: IStakeData = {} as IStakeData;
  userStaked: string = '0';
  poolPercent: number = 0;
  ethClaimable: string = '0';
  ethTokens: number = 0;

  userReward: string = '0';
  totalStaked: string = '0';
  userBal: number = 0;
  userBalString: string = '0';

  unstakeDate!: Date;
  canUnstake!: boolean;
  hash!: string;
  status!: SwapStatus;
  isWert: boolean = false;
  isClaimActive: boolean = false;
  bwUrl!: string;
  home = environment.domain;

  private readonly _platformId = inject(PLATFORM_ID);
  private readonly popupService = inject(PopupService);
  private readonly translate = inject(TranslateService);
  readonly stakingService = inject(StakingService);
  private modalRef = inject(BsModalRef);
  private readonly modalService = inject(BsModalService);
  private readonly cdRef = inject(ChangeDetectorRef);
  readonly dataService = inject(PresaleDataService);
  readonly purchaseService = inject(EvmPurchseService);
  private readonly analyticsService = inject(AnalyticsService);
  private readonly pixelService = inject(PixelService);

  @HostListener('window:resize')
  onResize() {
    this.view = [+this.graphCont().nativeElement.offsetWidth / 1.05, 400];
  }

  constructor() {
    this.checkPresaleStatus();
    let diff = 0;
    const date = new Date();
    const currMon = date.getUTCMonth();
    const currYear = date.getUTCFullYear();

    this.rewards.forEach((item: IReward, index: number) => {
      const itemDate = new Date(item.name);
      itemDate.setDate(itemDate.getDate() + 10);
      const itemMon = itemDate.getUTCMonth();
      const itemYear = itemDate.getUTCFullYear();
      if (itemYear === currYear && itemMon === currMon) {
        diff = index;
      }
    });

    this.colorScheme.domain[diff] = '#69DAFF';
    this.lang = this.translate.currentLang;
    this.home = `${environment.domain}${this.lang && this.lang !== 'en' ? '/' + this.lang : ''}`;

    this.translate.onLangChange.pipe(takeUntilDestroyed()).subscribe((params: LangChangeEvent) => {
      this.lang = params.lang;
      this.home = `${environment.domain}${this.lang && this.lang !== 'en' ? '/' + this.lang : ''}`;
    });

    // Re-sync all local display values whenever staking data refreshes (every 5s via StakingService)
    effect(() => {
      const item = this.stakingService.stakeData();
      if (item) this.updateAllgetMethod();
    });

    // Reflect transaction progress in the UI and trigger data refresh on completion
    effect(() => {
      const item = this.purchaseService.transactionUpdates();
      this.status = item.status;
      this.hash = item.hash as string;
      if (item.status === SwapStatus.complete) {
        clearTimeout(this.dataService.refreshId);
        this.dataService.getPresalesData(true);
        clearTimeout(this.stakingService.refreshId);
        this.stakingService.prepareStakingData();
      }
    });
  }

  ngOnDestroy(): void {
    this.ringsAnimationDestroy?.();
    clearTimeout(this.stakingService.refreshId);
    this.purchaseService.resetTransactionStatus();
  }

  ngOnInit(): void { }

  ngAfterViewInit() {
    if (isPlatformBrowser(this._platformId)) {
      this.pageLoaded = true;
      setTimeout(() => (this.view = [+this.graphCont().nativeElement.offsetWidth / 1.05, 400]), 500);
      this.cdRef.detectChanges();
      this.bwUrl = getParamWithoutCookie('bwUrl') as string;
      const instance = window.initRingsAnimation(this.ringsCanvas.nativeElement);
      this.ringsAnimationDestroy = instance?.destroy;
    }
  }

  updateAllgetMethod(): void {
    this.walletAddress = this.stakingService.walletAddress;
    this.stakeData = this.stakingService.stakeData();
    this.userStaked = this.walletAddress ? this.formatNumber(+(this.stakeData?.userStaked || 0).toFixed(0)) : '0';
    this.poolPercent = this.walletAddress && this.stakeData?.totalStaked ? +((this.stakeData.userStaked * 100) / this.stakeData.totalStaked).toFixed(5) : 0;
    this.userReward = this.walletAddress ? this.formatNumber(+(this.stakeData?.userReward || 0).toFixed(0)) : '0';
    this.ethClaimable = this.walletAddress ? this.formatNumber(+(this.dataService.balanceDataEVM?.ethClaimable || 0).toFixed(0)) : '0';

    this.ethTokens = this.walletAddress ? (this.dataService.balanceDataEVM?.ethClaimable ?? 0) : 0;
    this.totalStaked = this.formatNumber(+(this.stakeData?.totalStaked || 0).toFixed(0));
    this.userBalString = this.formatNumber(this.stakeData.userBal);
    this.userBal = this.stakeData.userBal;
    this.unstakeDate = new Date(this.stakeData.unlockTime * 1000);
    this.unstakeDate = this.unstakeDate.getTime() > this.stakeUnlockTime ? new Date(this.unstakeDate) : new Date(this.stakeUnlockTime);
    this.canUnstake = this.unstakeDate < new Date();
  }

  checkEthChain() {
    if (!this.walletAddress) {
      this.connectModal();
      return false;
    }
    if (this.dataService.chainId === environment.eth.chainIdInt) {
      return true;
    } else {
      this.popupService
        .messagePopup({
          icon: 'info',
          title: this.translate.instant('popup.change_network'),
          desc: this.translate.instant('popup.wrong_chain', { chainName: environment.eth.chainName }),
          confirmBtnTxt: this.translate.instant('misc.ok'),
        })
        .subscribe({
          next: (res: boolean) => {
            if (res) {
              this.dataService.switchNetwork(environment.eth.chainIdInt);
            }
          },
        });
      return false;
    }
  }

  openWithdrawModal(template: TemplateRef<void>) {
    if (!this.stakeData.isClaimEnabled) {
      this.popupService.messagePopup({ icon: 'info', desc: this.translate.instant('popup.withdraw_not_live'), confirmBtnTxt: this.translate.instant('misc.ok') });
      return;
    }
    this.modalRef = this.modalService.show(template, {
      class: 'modal-xs modal-dialog-centered',
      backdrop: 'static',
    });
  }
  openModal(template: TemplateRef<void>) {
    this.modalRef = this.modalService.show(template, {
      class: 'modal-xs modal-dialog-centered',
      backdrop: 'static',
    });
  }

  buyClaimStake(template: TemplateRef<void>): void {
    if (isPlatformBrowser(this._platformId)) {
      if (!this.checkEthChain()) {
        this.ngZone.runOutsideAngular(() => {
          this.timeInterval = setInterval(() => {
            this.ngZone.run(() => this.startConnectInterval(template));
          }, 2000);
        });
      } else if (this.walletAddress && this.ethTokens == 0) {
        this.openModal(template);
      }
    }
  }

  startConnectInterval(template: TemplateRef<void>) {
    if (this.walletAddress && this.dataService.chainId === environment.eth.chainIdInt) {
      this.openModal(template);
      clearInterval(this.timeInterval);
    }
  }

  claimAndStake(): void {
    if (this.ethTokens > 0 && this.checkEthChain()) {
      this.modalRef = this.modalService.show(ClaimComponent, {
        class: 'modal-xs modal-dialog-centered',
        backdrop: 'static',
        initialState: { isStake: true },
      });
      this.purchaseService.claimAndStake();
    }
  }

  closeModal() {
    this.modalRef!.hide();
  }

  public yAxisTickFormattingFn = this.yAxisTickFormatting.bind(this);

  yAxisTickFormatting(value: number) {
    return this.formatNumber(value / 1000000000) + 'B'; // this is where you can change the formatting
  }

  formatString(input: string): string {
    return input.toUpperCase();
  }

  formatNumber(input: number) {
    return convertNum(input);
  }

  withdrawStake(): void {
    if (isPlatformBrowser(this._platformId)) {
      if (this.stakeData.userStaked == 0 || !this.checkEthChain()) return;
      this.modalRef!.hide();
      setTimeout(() => {
        this.modalRef = this.modalService.show(ClaimComponent, {
          class: 'modal-xs modal-dialog-centered',
          backdrop: 'static',
          initialState: { isWithdraw: true },
        });
      }, 500);
      this.purchaseService.withdrawStake();
    }
  }

  harvestRewards(): void {
    if (isPlatformBrowser(this._platformId)) {
      if (!this.stakeData.isClaimEnabled) {
        this.popupService.messagePopup({ icon: 'info', desc: this.translate.instant('popup.claim_not_live'), confirmBtnTxt: this.translate.instant('misc.ok') });
        return;
      }
      if (this.stakeData.userReward > 0 && this.checkEthChain()) {
        this.purchaseService.harvestRewards();
        this.modalRef?.hide();
        setTimeout(() => {
          this.modalRef = this.modalService.show(ClaimComponent, {
            class: 'modal-xs modal-dialog-centered',
            backdrop: 'static',
          });
        }, 500);
      }
    }
  }

  max() {
    this.stakeAmount = this.stakeData.userBal;
  }

  stakeToken(template: TemplateRef<void>): void {
    if (isPlatformBrowser(this._platformId)) {
      if (this.checkEthChain() && this.stakeAmount <= this.userBal) {
        this.purchaseService.createStake(this.stakeAmount);
        this.modalRef!.hide();
        setTimeout(() => {
          this.modalRef = this.modalService.show(template, {
            class: 'modal-xs modal-dialog-centered',
            backdrop: 'static',
          });
        }, 1000);
      }
    }
  }

  connectModal(): void {
    this.dataService.connectWallet('ETH');
    this.analyticsService.vwoData('walletConnectionPlacement', { placement: 'Staking' });
  }

  poolInfo() {
    this.popupService.messagePopup({ icon: 'info', desc: this.translate.instant('staking.pool_share', { rewardRate: this.stakeData.rewardPerRound }), confirmBtnTxt: this.translate.instant('misc.ok') });
  }

  viewUrl() {
    if (isPlatformBrowser(this._platformId)) {
      if (typeof window == 'undefined') return;
      const blkUrl = environment.eth.blockExplorerURL;
      window.open(blkUrl + this.hash, '_blank');
    }
  }

  messageEvent(event: boolean) {
    this.isWert = event;
  }

  trackPartnerClick(): void {
    this.pixelService.trackPageClick('https://web3paymentsolutions.io/', 'web3payments');
  }

  checkPresaleStatus(): void {
    const presaleStartdate: number = 1778763600000;
    
    if (presaleStartdate > Date.parse(new Date().toString())) {
      this.isPresalestarted = false;
      return;
    }
    this.isPresalestarted = true;
  }
}
